module.exports = __webpack_public_path__ + "static/media/portalresulttres.cfad53bc.png";